import { render, staticRenderFns } from "./TransactionsSettingsOptions.vue?vue&type=template&id=4dc06cf8&scoped=true&"
import script from "./TransactionsSettingsOptions.vue?vue&type=script&lang=js&"
export * from "./TransactionsSettingsOptions.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsSettingsOptions.vue?vue&type=style&index=0&id=4dc06cf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc06cf8",
  null
  
)

export default component.exports